import { useNavigate } from '@tanstack/react-router';
import { Check, MessageSquare, RefreshCcw } from 'lucide-react';
import { useStore } from '../../store/useStore';

const PLATFORM_LABELS = {
  telegram: 'TG',
  whatsapp: 'WA',
  teams: 'Teams',
  email: '邮件',
  facebook: 'FB',
  instagram: 'INS',
};

export default function TasksView() {
  const { tasks, tasksLoading, error, loadTasks, completeTask, openTaskContact } = useStore();
  const navigate = useNavigate();

  const handleOpenTask = async (task) => {
    await openTaskContact(task);
    navigate({ to: '/messages' });
  };

  return (
    <main className="tasks-view">
      <div className="tasks-header">
        <div>
          <div className="tasks-title">任务</div>
          <div className="tasks-subtitle">{tasks.length} 个待处理提醒</div>
        </div>
        <button className="icon-btn" onClick={loadTasks} title="刷新任务" disabled={tasksLoading}>
          <RefreshCcw size={16} />
        </button>
      </div>

      {error && (
        <div className="tasks-error">{error}</div>
      )}

      <div className="tasks-list">
        {tasksLoading && (
          <div className="tasks-empty">正在加载任务...</div>
        )}
        {!tasksLoading && tasks.length === 0 && (
          <div className="tasks-empty">暂无待处理任务</div>
        )}
        {tasks.map(task => (
          <div key={task.id} className="task-row">
            <button className="task-check" onClick={() => completeTask(task.id)} title="完成任务">
              <Check size={15} />
            </button>
            <div className="task-main">
              <div className="task-text">{task.text}</div>
              <div className="task-meta">
                <span>{task.time || '待定'}</span>
                <span>{task.contactName || '未知客户'}</span>
                {task.company && <span>{task.company}</span>}
                {task.platform && <span>{PLATFORM_LABELS[task.platform] || task.platform}</span>}
              </div>
            </div>
            <button className="task-open" onClick={() => handleOpenTask(task)} title="打开会话">
              <MessageSquare size={15} />
              <span>打开</span>
            </button>
          </div>
        ))}
      </div>
    </main>
  );
}
